module.exports = __webpack_public_path__ + "img/paso3-img.ef0949dd.png";